import { PageHero, SectionHead, Bar } from "@/components/Shared";
import ImpactGrid, { useImpact } from "@/components/ImpactGrid";
import { num } from "@/lib/api";

const CHALLENGE = [["ponds_completed", "Pond-safety projects", 10], ["children_sponsored", "Children sponsored", 1000], ["families_educated", "Families reached", 1000], ["cpr_participants", "Caregivers in CPR education", 500], ["safety_days", "Community Safety Days", 10], ["corporate_sponsors", "Corporate / community sponsors", 50]];
const LADDER = [["Jacksonville Challenge", "10 Ponds • 1,000 Children"], ["100-Pond Challenge", "100 Ponds • 10,000 Children"], ["1,000-Pond Challenge", "1,000 Ponds • 100,000 Children"], ["The Million", "One Million Children Educated"]];

export default function Impact() {
  const { data } = useImpact();
  return (
    <div data-testid="impact-page">
      <PageHero eyebrow="Swim for Rakim Impact Center™" title="Show exactly what has been accomplished." sub="That's what turns a charitable mission into a measurable movement. All figures come from live program records." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12"><ImpactGrid extended /></section>
      <section className="bg-[#03045E] text-white py-16 relative grain">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHead light eyebrow="Swim for Rakim™ Jacksonville Challenge" title="10 Ponds • 1,000 Children • One City" sub="Aspirational program goals, not predictions." />
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
            {CHALLENGE.map(([k, l, goal]) => (
              <div key={k} className="rounded-2xl bg-white/5 border border-sky-400/20 p-5" data-testid={`challenge-${k}`}>
                <div className="flex justify-between items-end"><p className="font-semibold text-sky-100">{l}</p><p className="font-display text-2xl">{num(data?.[k])}<span className="text-sky-300 text-base"> / {num(goal)}</span></p></div>
                <div className="mt-3"><Bar value={data?.[k] || 0} max={goal} color="#FF6B35" /></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <SectionHead eyebrow="Then we scale" title="Physical infrastructure impact + human educational impact" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
          {LADDER.map(([t, d], i) => <div key={t} className="rounded-2xl bg-white border border-sky-100 p-6" style={{ opacity: 1 - i * 0.15 }}><p className="font-display text-4xl text-[#0096C7]">0{i + 1}</p><p className="font-display uppercase text-xl text-[#03045E] mt-2">{t}</p><p className="text-sm text-slate-600">{d}</p></div>)}
        </div>
      </section>
    </div>
  );
}
